import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { createFileRoute } from '@tanstack/react-router';
import { LibrariesIcon } from '@hugeicons-pro/core-stroke-rounded';
import { WorkspaceTypeIcon } from '@/features/workspaces/components/workspace-type-icon';
import { Breadcrumb, BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { Icon } from '@/ui/components/icon';
import { ArtifactsPage } from '@/features/artifacts/components/artifacts-page';
import { artifactsSearchSchema } from '@/features/artifacts/constants';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/',
)({
  component: RouteComponent,
  validateSearch: artifactsSearchSchema,
});

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const workspace = useWorkspace();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <Breadcrumb>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId"
            params={{ projectId, workspaceId }}
          >
            <WorkspaceTypeIcon type={workspace.type} />
            <span className="line-clamp-1">{workspace.name}</span>
          </BreadcrumbLink>
          <BreadcrumbPage>
            <Icon icon={LibrariesIcon} />
            {t({ en: 'Working documents', nb: 'Arbeidsdokumenter' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderChatButton />
      </Header>
      <ArtifactsPage />
    </>
  );
}
